import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import decodeSearchObjFromQueryString from '../utils/decodeSearchObjFromQueryString';
import getSearchFilterQueryFromRouterQuery from '../utils/getSearchFilterQueryFromRouterQuery';
import { SearchModes } from '../constants';

const queryStringParser = require('query-string');

function useSearchObjFromQueryString(onChangeSearchObj = () => { }, queryString,
  doLoadDataFromQueryString = true) {
  const router = useRouter();
  const { searchMode = SearchModes.CRUISE_TRIP } = router.query;
  const {
    cruiseLinesAutocompleteResults,
    cruiseShipsAutocompleteResults,
    destinationsAutocompleteResults,
  } = useSelector((store) => store.autocomplete);
  // The `travelAgency` data is crucial for validating check-in and check-out
  // dates. Ensure `travelAgency` is available upon component
  // reloads or URL-based searches, as it might be null for some agencies.
  const { travelAgency } = useSelector((store) => store.user);

  const isLoadedAutocompleteResults = useMemo(
    () => doLoadDataFromQueryString
      && (searchMode === SearchModes.CRUISE_TRIP ? (cruiseLinesAutocompleteResults.length > 0
      && cruiseShipsAutocompleteResults.length > 0
      && destinationsAutocompleteResults.length > 0) : true),
    [
      doLoadDataFromQueryString,
      cruiseLinesAutocompleteResults.length,
      cruiseShipsAutocompleteResults.length,
      destinationsAutocompleteResults.length,
      searchMode,
    ],
  );

  useEffect(() => {
    if (isLoadedAutocompleteResults) {
      const query = getSearchFilterQueryFromRouterQuery(queryString
        ? queryStringParser.parse(queryString) : router.query);
      const decodedSearchObjectFromQueryString = decodeSearchObjFromQueryString(
        query,
        destinationsAutocompleteResults,
        cruiseShipsAutocompleteResults,
        cruiseLinesAutocompleteResults,
        searchMode,
      );
      if (Object.keys(decodedSearchObjectFromQueryString).length && travelAgency) {
        onChangeSearchObj(decodedSearchObjectFromQueryString);
      }
    }
    // because autocomplete results changes every time when we set a query filter
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadedAutocompleteResults, travelAgency]);
}

export default useSearchObjFromQueryString;
